import { getDocumentos } from '../../Dashboard/DeclarationSummary/DocumentosModal';
import { getDocumentosTipos } from '../../Dashboard/DeclarationSummary/DocumentosModal';

// Simple text display component
const TextDisplay = ({ value, className = "" }) => {
  const displayValue = value === null || value === undefined || value === '' ? 'null' : value;
  return (
    <p className={`${className} py-1`}>{displayValue}</p>
  );
};

export const DeclarationDocumentsTableContent = ({
  declarationIndex,
  isSpanish,
  declaration,
  editableData,
  setEditableData,
  setIsDirty,
  openDocModalIndex,
  setOpenDocModalIndex,
  openTipoModal,
  setOpenTipoModal,
}) => {
  const documentos = getDocumentos();

  return (
    <div className="overflow-auto">
      <table className="min-w-full border-collapse text-sm">
        <thead>
          <tr>
            <th className="py-2 px-4 pt-2 pl-0">
              <p className="w-max">
                {!isSpanish ? "Document Code" : "Código de Documento"}
              </p>
            </th>
            <th className="py-2 px-4 pt-2">
              <p className="w-max">{!isSpanish ? "Type" : "Tipo"}</p>
            </th>
            <th className="py-2 px-4 pt-2">
              <p className="w-max">{!isSpanish ? "Number" : "Número"}</p>
            </th>
            <th className="py-2 px-4 pt-2">
              <p className="w-max">{!isSpanish ? "Date" : "Fecha"}</p>
            </th>
          </tr>
        </thead>
        <tbody>
          {declaration.documentos?.map((doc, docIndex) => {
            const selectedDoc = documentos.find(d => d.codigo === doc.codigo_documento || d.nombre === doc.codigo_documento);
            const tipos = getDocumentosTipos();
            const selectedTipo = tipos.find(t => t.codigo === String(doc.tipo));
            
            return (
              <tr key={docIndex}>
                <td className="py-4 px-4 pl-0 border-t">
                  <TextDisplay
                    value={selectedDoc
                      ? `${selectedDoc.codigo}${selectedDoc.nombre ? ` (${selectedDoc.nombre})` : ''}`
                      : doc.codigo_documento
                    }
                  />
                </td>
                <td className="py-4 px-4 border-t">
                  <TextDisplay
                    value={selectedTipo
                      ? `${selectedTipo.codigo}${selectedTipo.nombre ? ` (${selectedTipo.nombre})` : ''}`
                      : doc.tipo
                    }
                  />
                </td>
                <td className="py-4 px-4 border-t">
                  <TextDisplay value={doc.numero} />
                </td>
                <td className="py-4 border-t">
                  <TextDisplay value={doc.fecha} />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

